import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer

let service = new services();

export default {
    name: 'CNpay',
    data () {
        return {
            user: {},
            payment_details:{},
            cnpay_transactions:{},
            cnpay_transaction:{},
            cnpay_transaction_type:1,
            loading:true,
            disable_btn:false,
            show_payment_receipt:true,
            downloading:false,
            img_url: service.imageURL,
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        setPanel() {
            this.panelFlag = true
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },

        setFormattedVoucher(voucher){
            if((voucher != '') || (voucher != undefined)){
                let s_voucher = String(voucher).replace('--','');
                return String(s_voucher).match(/.{1,4}/g).join('-');
            }
        },

        closeModal(modal){
            $(modal).modal("hide");
            //some refresh
            this.wallet_transaction = {};
            this.wallet_payment_calculated= false;
            this.wallet_payment_message = '';
            this.wallet_payment_error_message='';
        },
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

       
        getCNpayTransactions() {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getCNpayTransactions(this,user_id).then(data => {
                this.cnpay_transactions = data.body.data;
                this.loading = false;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        setTransaction(txn,type){
            this.show_payment_receipt = false; //reset
            this.cnpay_transaction = txn.cnpay_txn_details;
            this.cnpay_transaction_type = type;
        },
        
        //
        printDiv(divId,title) {

            let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');
            // let mywindow = window.open('', 'PRINT', 'height=650,width=350,top=100,left=150');

            mywindow.document.write(`<html><head><title>${title}</title>`);
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            return true;
        },

        saveDiv(divId, title) {
            this.downloading = true;
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width; 
            var HTML_Height = d_position.height; 
            
            var element = document.getElementById(divId);
            var opt = {
                margin:   1,//[-3, 1, 2, 1],// 1,
                filename: title+'.pdf',
                image:    { type: 'jpeg', quality: 0.98 },
                html2canvas: { allowTaint:true, useCORS:true, scale: 2},
                // jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                // jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
                jsPDF: { unit: 'mm', format: [312, 592], orientation: 'portrait' }
            };
            
            // New Promise-based usage:
            // html2pdf().set(opt).from(element).save();
            //--to check for output time
            let self = this;
            html2pdf().set(opt).from(element).save().then(function () {
                //
                //console.log('saving');
                setTimeout(function (){
                    self.downloading = false;
                }, 2500);
            });
        },
        
    },
    created: function(){
        this.preset();
        this.getCNpayTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNpayTransactions/script.js